@if (isLoading()) {
  <aw-loading-animation></aw-loading-animation>
} @else {
  @let id = 'orders-overview';
  <div class="flex flex-row items-center justify-between pb-12">
    <div
      class="text-3xl"
      [attr.data-testid]="id | appendTestId: 'orders-headline'">
      {{ cmsTextProvider.ticket.orders }}
    </div>
    <div class="flex w-2/3 flex-row gap-4">
      <aw-drop-down
        id="order-time-filter"
        [options]="timeFilterOptions"
        name="name"
        valueAttribute="value"
        [label]="cmsTextProvider.ticket.timeFrame"
        [formControl]="timeFrameControl"></aw-drop-down>
      <aw-text-input
        id="order-search"
        [label]="cmsTextProvider.shared.search"
        [placeholder]="cmsTextProvider.ticket.searchPlaceholder"
        [formControl]="searchControl"></aw-text-input>
    </div>
  </div>
  <aw-table
    id="ticket-table"
    [data]="shownOrders()"
    [defaultPageSize]="5"
    rowFlow="nowrap"
    [header]="header"
    [expandable]="true"
    [rowKey]="orderRowKey"
    [expandedRowTemplate]="expandedRow"
    [columns]="columns">
    <ng-template #header let-sortBy="sortBy">
      <aw-table-header
        cellName="actions"
        class="w-full overflow-hidden"
        [attr.data-testid]="id | appendTestId: 'header-status'"
        (onSort)="sortBy($event)">
        {{ cmsTextProvider.orderOverview.actions }}
      </aw-table-header>
      <aw-table-header
        cellName="date"
        class="w-full overflow-hidden"
        [attr.data-testid]="id | appendTestId: 'header-date'"
        [sortParams]="{
          attribute: 'date',
          compare: orderDateFilter,
        }"
        (onSort)="sortBy($event)">
        {{ cmsTextProvider.orderOverview.date }}
      </aw-table-header>
      <aw-table-header
        cellName="time"
        class="w-full overflow-hidden text-nowrap"
        [attr.data-testid]="id | appendTestId: 'header-time'"
        [sortParams]="{
          attribute: 'time',
          compare: orderDateFilter,
        }"
        (onSort)="sortBy($event)">
        {{ cmsTextProvider.orderOverview.time }}
      </aw-table-header>
      <aw-table-header
        cellName="email"
        class="w-full overflow-hidden"
        [sortParams]="{
          attribute: 'email',

          compare: orderDataFilter,
        }"
        [attr.data-testid]="id | appendTestId: 'header-email'"
        (onSort)="sortBy($event)">
        {{ cmsTextProvider.orderOverview.email }}
      </aw-table-header>

      <aw-table-header
        cellName="payment"
        class="w-full overflow-hidden"
        [sortParams]="{
          attribute: 'paymentMethodName',
          compare: orderDataFilter,
        }"
        (onSort)="sortBy($event)"
        [attr.data-testid]="id | appendTestId: 'header-payment'">
        {{ cmsTextProvider.orderOverview.payment }}
      </aw-table-header>
      <aw-table-header
        cellName="orderId"
        class="w-full overflow-hidden"
        [sortParams]="{
          attribute: 'id',
          compare: orderDataFilter,
        }"
        (onSort)="sortBy($event)"
        [attr.data-testid]="id | appendTestId: 'header-order-id'">
        {{ cmsTextProvider.orderOverview.orderId }}
      </aw-table-header>
      <aw-table-header
        cellName="sum"
        [sortParams]="{
          attribute: 'totalPrice',
          compare: orderTotalPriceFilter,
        }"
        (onSort)="sortBy($event)"
        [attr.data-testid]="id | appendTestId: 'header-sum'">
        {{ cmsTextProvider.orderOverview.sum }}
      </aw-table-header>
    </ng-template>
    <ng-template
      #columns
      let-data="data"
      let-toggleExpanded="toggleExpanded"
      let-isExpanded="isExpanded"
      let-index="index">
      @let creationDate = data.createdAt | date: DATE_FORMAT;
      @let creationTime = data.createdAt | date: TIME_FORMAT_SHORT;
      @let email = data.personalData.email;
      @let orderId = data.id;
      @let paymentMethod = data.paymentMethod.displayName;
      @let totalPrice = data.totalPrice.formattedPrice;
      <aw-table-cell
        cellName="actions"
        class="justify-start gap-2"
        [attr.data-testid]="id | appendTestId: 'expand-' + data.id">
        <button
          type="button"
          class="material-symbols-rounded cursor-pointer text-lg"
          (click)="toggleExpanded(data, index)"
          [attr.aria-label]="
            isExpanded(data, index)
              ? 'Details ausklappen'
              : 'Details einklappen'
          ">
          {{ isExpanded(data, index) ? 'expand_more' : 'chevron_right' }}
        </button>
        <span
          class="material-symbols-rounded cursor-pointer"
          [attr.data-testid]="id | appendTestId: 'cancel' + data.id"
          >cancel</span
        >
        <span
          class="material-symbols-rounded cursor-pointer"
          [attr.data-testid]="id | appendTestId: 'send' + data.id"
          >send</span
        >
        <span
          class="material-symbols-rounded cursor-pointer"
          [attr.data-testid]="id | appendTestId: 'paid' + data.id"
          >paid</span
        >
      </aw-table-cell>
      <aw-table-cell
        cellName="date"
        class="text-nowrap"
        [attr.data-testid]="id | appendTestId: 'date-' + data.id">
        {{ creationDate }}
      </aw-table-cell>
      <aw-table-cell
        cellName="time"
        class="text-nowrap"
        [attr.data-testid]="id | appendTestId: 'time-' + data.id">
        {{ creationTime }}
      </aw-table-cell>
      <aw-table-cell
        cellName="email"
        class="w-full overflow-hidden"
        [attr.data-testid]="id | appendTestId: 'email-' + data.id">
        {{ email }}
      </aw-table-cell>
      <aw-table-cell
        cellName="payment"
        class="w-full overflow-hidden"
        [attr.data-testid]="id | appendTestId: 'payment-' + data.name">
        {{ paymentMethod || '-' }}
      </aw-table-cell>
      <aw-table-cell
        cellName="orderId"
        class="w-full overflow-hidden"
        [attr.data-testid]="id | appendTestId: 'order-id-' + data.id">
        {{ orderId }}
      </aw-table-cell>
      <aw-table-cell
        cellName="sum"
        class="flex w-full justify-end overflow-hidden"
        [attr.data-testid]="id | appendTestId: 'sum-' + data.id">
        {{ totalPrice }}
      </aw-table-cell>
    </ng-template>
    <ng-template #expandedRow let-data="data">
      <div
        class="border-standard-outline bg-standard-hover-main/10 w-full rounded-lg border p-4">
        <div class="mb-4 text-lg font-semibold">
          {{ cmsTextProvider.orderOverview.detailsHeadline }}
        </div>

        <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.email }}
            </div>
            <div>{{ data.personalData.email }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.status }}
            </div>
            <aw-order-status-chip
              [id]="'details-' + data.id + '-status-ship'"
              [type]="EStatusChipType.dark"
              [orderEvents]="data.events"></aw-order-status-chip>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.comment }}
            </div>
            <div>{{ data.comment }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.payment }}
            </div>
            <div>{{ data.paymentMethod.displayName || '-' }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.paymentType }}
            </div>
            <div>{{ data.paymentProvider }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.orderId }}
            </div>
            <div>{{ data.id }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.userId }}
            </div>
            <div>{{ data.userId }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.sum }}
            </div>
            <div>{{ data.totalPrice.formattedPrice }}</div>
          </div>

          <div class="flex flex-col gap-1">
            <div class="font-semibold">
              {{ cmsTextProvider.orderOverview.date }}
            </div>
            <div>
              {{ data.createdAt | date: DATE_FORMAT }}
              {{ data.createdAt | date: TIME_FORMAT_SHORT }}
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div class="mb-2 text-lg font-semibold">
            {{ cmsTextProvider.ticket.orderTickets }}
          </div>
          <aw-bookings-overview
            [events]="data.events"
            [bookings]="data.bookings"
            [id]="data.id"></aw-bookings-overview>
        </div>
      </div>
    </ng-template>
  </aw-table>
}
